import { Controller } from 'stimulus';

const UNPROCESSABLE_ENTITY = 422;

export default class ApplicationFormController extends Controller {
  static targets = ['submit'];

  connect() {
    this.genericError = $('#flash-container').html();
  }

  submit(event) {
    event.preventDefault();
    const data = new FormData(event.target);

    this._hideErrors();
    this.submitTarget.disabled = true;

    this._createApplication(data)
      .then((data) => this._onSuccess(data))
      .catch((error) => this._onError(error));
  }

  capSelections(event) {
    const group = event.currentTarget;
    const boxes = Array.from(group.querySelectorAll('input[type="checkbox"]'));
    const full = boxes.filter((box) => box.checked).length >= Number(group.dataset.maxChoices);

    boxes.forEach((box) => {
      box.disabled = full && !box.checked;
    });
  }

  _createApplication(body) {
    const endpoint = window.location.href;

    return fetch(endpoint, { method: 'POST', body }).then((res) => {
      return res
        .json()
        .then((data) => {
          res.data = data;
        })
        .catch(Object)
        .then(() => (res.ok ? res : Promise.reject(res)));
    });
  }

  _onSuccess(response) {
    window.location.href = response.data.redirect_url;
  }

  _onError(response) {
    this.submitTarget.disabled = false;

    if (response.status === UNPROCESSABLE_ENTITY) {
      this._handleValidationErrors(response.data);
      return;
    }

    this._showFlashError();
  }

  _hideErrors() {
    $('[data-error-field]').addClass('hidden').html('');
    $('[name]').removeClass('border-red-550').addClass('border-gray-150');
    $('#flash-container').addClass('hidden');
  }

  _handleValidationErrors(errors) {
    let firstErrorElement = null;
    let rendered = false;

    $.each(errors, function (field, messages) {
      const errorFieldElement = $(`[data-error-field="${field}"]`);
      if (errorFieldElement.length) {
        errorFieldElement.removeClass('hidden').html(messages[0]);
        rendered = true;
      }
  
      const inputElement = $(`[name="${field}"]`);
      if (inputElement.length) {
        inputElement.addClass('border-red-550').removeClass('border-gray-150');
  
        if (!firstErrorElement) {
          firstErrorElement = inputElement;
        }
      }
    });

    if (firstErrorElement) {
      firstErrorElement.focus();
    }

    if (!rendered) {
      this._showFlashError();
    }
  }

  _showFlashError() {
    $('#flash-container').html(this.genericError).removeClass('hidden');
  }
}
